import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getPrograms } from 'reducers/programs';
import { getAvailablePrograms } from 'reducers/availablePrograms';
import Purchased from 'components/Pages/Programs/User/Purchased';

const mapStateToProps = (state) => {
  return {
    userPrograms: getPrograms(state),
    availablePrograms: getAvailablePrograms(state),
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Purchased);
